import flatten from 'lodash/flatten';
import urlJoin from '@framework/url/helpers/urlJoin';
import baseUrl from '@framework/url/baseUrl';
import domain from '@framework/config/domain';
import config from '@allocate/config';
import usersUrl from '@/users/infrastructure/usersUrl';
import dmPortalUrl from '@/dmPortal/infrastructure/url/dmPortalUrl';

export default {
  getUrl(uris: Array<string> | string = []) {
    if (!Array.isArray(uris)) {
      uris = [uris];
    }
    uris = flatten(uris).filter((uri) => !!uri);
    return urlJoin(`${ domain.protocol }//${ config.hostname }`, ...uris);
  },

  getRpcUrl(): string {
    return `${ config.api.external }/proxy/api/rpc`;
  },

  getPropagateCallbackUrl(url: string): string {
    return baseUrl.getRestUrl(
      `/propagate?callbackUrl=${ encodeURIComponent(url) }&tenant=${ config.code }`,
    );
  },

  getRegisterUrl(): string {
    return usersUrl.getRegisterUrl(this.getPropagateCallbackUrl(this.getUrl('/')), config.code);
  },

  getLoginUrl(): string {
    return usersUrl.getLoginUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/allocate')),
      config.code,
    );
  },
};
